import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { RegisterPatientErrorResponse } from "./register-patient.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseRegisterPatientOptions = {
  config?: MutationConfig<
    typeof vouchersDistributionsRepository.registerPatient,
    AxiosError<RegisterPatientErrorResponse>
  >;
};

export const useRegisterPatient = ({ config }: UseRegisterPatientOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.registerPatient(data),
  });
};
